import React from 'react';

const Info = () => {
  return (
    <div className='about__info grid'>
      <div className='about__box'>
        <i className='bx bx-brain about__icon'></i>
        <h3 className='about__title'>Specialization</h3>
        <span className='about__subtitle'>AI / ML Engineering</span>
        <span className='about__subtitle'>MLOps & GenAI</span>
      </div>

      <div className='about__box'>
        <i className='bx bx-code-alt about__icon'></i>
        <h3 className='about__title'>Projects</h3>
        <span className='about__subtitle'>ML, RAG & ETL Pipelines</span>
        <span className='about__subtitle'>Production-ready Repos</span>
      </div>

      <div className='about__box'>
        <i className='bx bx-cloud about__icon'></i>
        <h3 className='about__title'>Platforms</h3>
        <span className='about__subtitle'>Cloud & Local</span>
        <span className='about__subtitle'>Azure-focused</span>
      </div>
    </div>
  );
};

export default Info;
